module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "become-client column is-one-third is-pulled-left"
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteBecomeClientData(_vm.becomeClientData.id)
      }
    }
  }), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Заголовок",
      "required": ""
    },
    on: {
      "change": function($event) {
        return _vm.updateBecomeClientData(_vm.becomeClientData)
      }
    },
    model: {
      value: (_vm.becomeClientData.title),
      callback: function($$v) {
        _vm.$set(_vm.becomeClientData, "title", $$v)
      },
      expression: "becomeClientData.title"
    }
  })], 1), _vm._v(" "), _c('Editor', {
    attrs: {
      "editorToolbar": _vm.customToolbar,
      "placeholder": "Текст информации",
      "id": 'become-client-id-' + _vm.becomeClientData.id
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b13b8b5e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Services/BecomeClient.vue
// module id = 991
// module chunks = 0